export const NOTIFICATIONS_BACKEND_MODULE_KEY = 'Notifications';
export const NOTIFICATIONS_MODULE_KEY = 'notifications';
export const ORG_BASE_ROUTE = '/organizations';
export const USERS_URL = 'users';
